import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./App";
import { boot } from "./core/session";
import "./ui/theme.css";
import "./ui/components.css";
import "./components/shell.css";

void boot();

// 仅开发构建：把核心层挂到 window.kp，方便在控制台 / Playwright 里调试（例如 await kp.upload(file)）
if (import.meta.env.DEV) {
  void import("./core").then((core) => {
    (window as unknown as { kp: typeof core }).kp = core;
  });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
